/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$preloader-circle-theme-color1: #1ea2b1 !default;
$preloader-circle-theme-color2: #e3e000 !default;
$preloader-circle-theme-color3: #ea1b0a !default;
$preloader-circle-theme-color4: #b00402 !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$pi: 3.14159265358979; // PI
$radius: 24px;
$radiusSmall: 12px;
$fullCircle: $radius * 2 * $pi; // 2 * PI * Radius = circumference
$fullCircleSmall: $radiusSmall * 2 * $pi; // 2 * PI * Radius = circumference
$duration: 1500ms;
$durationSmall: 1250ms;

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    stroke-dashoffset: -$fullCircle;
  }
  100% {
    stroke-dashoffset: -$fullCircle * 3;
    stroke-dasharray: $fullCircle * 0.5 $fullCircle * 1.5;
  }
}

@keyframes spinSmall {
  0% {
    stroke-dashoffset: -$fullCircleSmall;
  }
  100% {
    stroke-dashoffset: -$fullCircleSmall * 3;
    stroke-dasharray: $fullCircleSmall * 0.5 $fullCircleSmall * 1.5;
  }
}

// Animate Stroke Color
@keyframes color {
  0%,
  25% {
    stroke: $preloader-circle-theme-color1;
  }
  26%,
  50% {
    stroke: $preloader-circle-theme-color2;
  }
  51%,
  75% {
    stroke: $preloader-circle-theme-color3;
  }
  76%,
  100% {
    stroke: $preloader-circle-theme-color4;
  }
}

:host {
  display: inline-block;
}

.#{$prefix}preloader-wrapper {
  position: relative;

  .#{$prefix}preloader-spinner {
    width: 64px;
    height: 64px;
    fill: none;
    stroke-width: 4px;
    animation: rotate $duration linear infinite;

    svg {
      .spinner {
        stroke: v(spinnerColor);
        animation: spin $duration linear infinite;
        stroke-dasharray: $fullCircle $fullCircle;
        stroke-dashoffset: -$fullCircle;
      }

      .track {
        stroke: v(trackColor);
      }
    }
  }

  &.#{$prefix}small {
    .#{$prefix}preloader-spinner {
      width: 40px;
      height: 40px;
      stroke-width: 4px;
      animation: rotate $durationSmall linear infinite;

      svg {
        .spinner {
          animation: spinSmall $durationSmall linear infinite;
          stroke-dasharray: $fullCircleSmall $fullCircleSmall;
          stroke-dashoffset: -$fullCircleSmall;
        }
      }
    }
  }

  &.#{$prefix}colorful {
    .#{$prefix}preloader-spinner {
      svg {
        .spinner {
          animation: spin $duration linear infinite, color $duration * 4 linear infinite;
        }
      }
    }

    &.#{$prefix}small {
      .#{$prefix}preloader-spinner {
        svg {
          .spinner {
            animation: spinSmall $durationSmall linear infinite, color $durationSmall * 4 linear infinite;
          }
        }
      }
    }
  }
}
